import { Spinner } from '@chakra-ui/react';
import { useUserPreference } from 'hooks/datahook/settings';
import { get, last } from 'lodash';
import PropTypes from 'prop-types';
import {Navigate} from 'react-router-dom';
import {authPaths} from 'routes/path';
import {useAuthStore} from 'stores/authStore';

// ----------------------------------------------------------------------

PassOtpResetRequiredGuard.propTypes = {
    children: PropTypes.node,
};

export default function PassOtpResetRequiredGuard({children}) {
    const {data: preference, kycVerified, isLoading} = useUserPreference();
    const [last2faDate, setLast2faDate] = useAuthStore((state) => [state.last2faDate, state.setLast2faDate]);
    if(isLoading){
        return <Spinner/>
    }
    if(get(preference, 'requiredUpdatePassword')){
        return <Navigate to={authPaths.requiredUpdatePassOtp} />;
    }
    if(kycVerified) {
        if(last2faDate){
            if(last2faDate > get(preference, 'last2faDate')) {
                if (
                    (!get(preference, 'enableSmsFact') && !get(preference, 'enableOtpFact'))
                ) {
                    return <Navigate to={authPaths.requiredUpdatePassOtp} />;
                }
            }
        }else{
            // skip to dashboard by default
            // Restore forced 2fa settings, notion-576
            if(kycVerified) {
                if (
                    (!get(preference, 'enableSmsFact') && !get(preference, 'enableOtpFact'))
                ) {
                    return <Navigate to={authPaths.requiredUpdatePassOtp} />;
                }
            }
        }
    }
    return <>{children}</>;
}
